import React from 'react';

const ApiKeyIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.99988 9.33254L6.66654 7.99921L7.99988 6.66588L9.33321 7.99921L7.99988 9.33254ZM6.58321 5.64654L5.45521 4.51921L7.24188 2.73187C7.34987 2.62432 7.46988 2.54565 7.60188 2.49587C7.73476 2.44654 7.86743 2.42188 7.99988 2.42188C8.13232 2.42188 8.26476 2.44654 8.39721 2.49587C8.52965 2.54521 8.64965 2.62387 8.75721 2.73187L10.5445 4.51854L9.41654 5.64721L7.99988 4.22988L6.58321 5.64654ZM4.51921 10.5439L2.73188 8.75721C2.62432 8.64921 2.54565 8.52921 2.49588 8.39721C2.44654 8.26432 2.42188 8.13165 2.42188 7.99921C2.42188 7.86676 2.44654 7.73432 2.49588 7.60188C2.54521 7.46943 2.62388 7.34943 2.73188 7.24188L4.51854 5.45454L5.64721 6.58254L4.23054 7.99921L5.64721 9.41588L4.51921 10.5439ZM11.4805 10.5439L10.3525 9.41588L11.7692 7.99921L10.3525 6.58254L11.4805 5.45454L13.2679 7.24121C13.3754 7.34921 13.4541 7.46921 13.5039 7.60121C13.5532 7.7341 13.5779 7.86676 13.5779 7.99921C13.5779 8.13165 13.5532 8.2641 13.5039 8.39654C13.4545 8.52899 13.3759 8.64899 13.2679 8.75654L11.4805 10.5439ZM7.24254 13.2672L5.45521 11.4805L6.58321 10.3519L7.99988 11.7685L9.41654 10.3519L10.5445 11.4799L8.75787 13.2672C8.64988 13.3748 8.52988 13.4534 8.39788 13.5032C8.26499 13.5525 8.13232 13.5772 7.99988 13.5772C7.86743 13.5772 7.73499 13.5525 7.60254 13.5032C7.4701 13.4539 7.3501 13.3752 7.24254 13.2672Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ApiKeyIcon;
